import { useIsFeatureFlagActive, usePermissions } from '@klareospace/pharos-lib-front-utils';

import { FEATURE_FLAGS } from '&/feature-flags';

// ─── Constants ──────────────────────────────────────────────────────────────

const KPIS_READ_PERMISSION = 'kpis:read';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** True when the `feat-dashboard` flag is active AND the user holds `kpis:read`. */
export function useIsKpiReadEnabled(): boolean {
  const isDashboardActive = useIsFeatureFlagActive(FEATURE_FLAGS.DASHBOARD);
  const { hasPermission } = usePermissions();
  return isDashboardActive && hasPermission(KPIS_READ_PERMISSION);
}
